import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GlobalService } from 'src/app/services/helper/global-helper';

@Component({
  selector: 'app-visualization-distributor',
  templateUrl: './visualization-distributor.component.html',
  styleUrls: ['./visualization-distributor.component.scss']
})
export class VisualizationDistributorComponent {

  line: string = '';
  path: string = '';
  
  constructor(private global: GlobalService, public activatedRoute: ActivatedRoute) {
    // fetch line of machine
    this.global.machineInfos.subscribe({
      next: newValue => {this.line = newValue.line;}
    });
    // fetch url path
    this.activatedRoute.url.subscribe(params => {
      params.forEach((url) => {
        this.path = this.path.concat(this.path, url.path.toString());
      });
    });
  }

}
